import Image from '@/components/Image';
import { selectSailingData } from '@/ducks/voyageInfo/sailing/selectors';
import { FormattedMessage } from '@/helpers/formatted-message';
import { checkForValueType } from '@/helpers/util';
import { useAppSelector } from '@/store';

import './VoyageExperience.scss';

const VoyageExperience = () => {
  const itineraryUSPs = useAppSelector((state) => selectSailingData(state).itineraryUSPs);
  if (!checkForValueType(itineraryUSPs)) {
    return <div className="VoyageExperienceEmpty" />;
  }
  return (
    <div className="VoyageExperience">
      <h2 className="experinceHeading">
        <FormattedMessage defaultMessage="The Virgin Voyages Experience" id="Itinerary.USP.heading" />
      </h2>
      <div className="voyageExperienceRows">
        {checkForValueType(itineraryUSPs) &&
          itineraryUSPs.map((usp, index) => (
            <div className="voyageExperienceRow" key={index}>
              <div className="experienceImage">
                {' '}
                <Image alt={usp?.image?.alt} src={usp?.image?.src} />
              </div>
              <div className="experienceTextContent">
                <h3 className="experienceName">{usp?.name}</h3>
                <p className="experienceDescription">{usp?.description}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default VoyageExperience;
